import React from 'react'
import { Button, DatePicker } from 'components/ui'
import {
    HiChevronLeft,
    HiChevronRight,
    HiOutlineCalendar,
} from 'react-icons/hi'

const CALENDAR_VIEWS = [
    { value: 'dayGridMonth', label: 'Mois' },
    { value: 'timeGridWeek', label: 'Semaine' },
    { value: 'timeGridDay', label: 'Jour' },
]

const CalendarToolbar = ({
    viewState,
    toolbarActions,
    handleDatePickerChange,
    navigateCalendar,
    changeCalendarView,
}) => (
    <section
        className="calendar-command-bar"
        aria-label="Commandes du calendrier"
    >
        <div className="calendar-command-heading">
            <div className="min-w-0">
                <span className="calendar-command-eyebrow">
                    Planning des rendez-vous
                </span>
                <h2 className="calendar-command-title">{viewState.title}</h2>
            </div>
            {toolbarActions && (
                <div className="calendar-command-actions">{toolbarActions}</div>
            )}
        </div>

        <div className="calendar-command-controls">
            <div className="calendar-date-controls">
                <div className="calendar-date-picker">
                    <DatePicker
                        value={viewState.date}
                        onChange={handleDatePickerChange}
                        inputFormat="DD MMM YYYY"
                        inputSuffix={<HiOutlineCalendar className="text-lg" />}
                        placeholder="Aller à une date"
                        className="w-full"
                        size="sm"
                        locale="fr"
                        clearable={false}
                    />
                </div>
                <Button
                    type="button"
                    size="sm"
                    variant="default"
                    className="calendar-today-button"
                    onClick={() => handleDatePickerChange(new Date())}
                >
                    Aujourd'hui
                </Button>
            </div>

            <div className="calendar-navigation-controls">
                <div
                    className="calendar-view-switch"
                    role="group"
                    aria-label="Vue du calendrier"
                >
                    {CALENDAR_VIEWS.map((view) => (
                        <Button
                            key={view.value}
                            type="button"
                            size="sm"
                            shape="none"
                            variant={
                                viewState.type === view.value
                                    ? 'solid'
                                    : 'plain'
                            }
                            className="calendar-view-button"
                            aria-pressed={viewState.type === view.value}
                            onClick={() => changeCalendarView(view.value)}
                        >
                            {view.label}
                        </Button>
                    ))}
                </div>
                <div className="calendar-stepper">
                    <Button
                        type="button"
                        size="sm"
                        variant="default"
                        icon={<HiChevronLeft />}
                        aria-label="Période précédente"
                        onClick={() => navigateCalendar('previous')}
                    />
                    <Button
                        type="button"
                        size="sm"
                        variant="default"
                        icon={<HiChevronRight />}
                        aria-label="Période suivante"
                        onClick={() => navigateCalendar('next')}
                    />
                </div>
            </div>
        </div>
    </section>
)

export default CalendarToolbar
